export default {
  CREATE_RSEE_DISCOUNT_REQUEST_LOADING: 'CREATE_RSEE_DISOCUNT_REQUEST_LOADING',
  CREATE_RSEE_DISCOUNT_REQUEST_SUCCESS: 'CREATE_RSEE_DISOCUNT_REQUEST_SUCCESS',
  CREATE_RSEE_DISCOUNT_REQUEST_FAILED: 'CREATE_RSEE_DISOCUNT_REQUEST_FAILED',
  CREATE_RSEE_DISCOUNT_REQUEST_REJECT: 'CREATE_RSEE_DISOCUNT_REQUEST_REJECT',

  GET_MY_RSEE_DISCOUNTS_LIST_LOADING: 'GET_MY_RSEE_DISCOUNTS_LIST_LOADING',
  GET_MY_RSEE_DISCOUNTS_LIST_SUCCESS: 'GET_MY_RSEE_DISCOUNTS_LIST_SUCCESS',
  GET_MY_RSEE_DISCOUNTS_LIST_FAILED: 'GET_MY_RSEE_DISCOUNTS_LIST_FAILED',
  GET_MY_RSEE_DISCOUNTS_LIST_REJECT: 'GET_MY_RSEE_DISCOUNTS_LIST_REJECT',

  FETCH_ALL_RSEE_DISCOUNT_REQUESTS_LOADING: 'FETCH_ALL_RSEE_DISCOUNT_REQUESTS_LOADING',
  FETCH_ALL_RSEE_DISCOUNT_REQUESTS_SUCCESS: 'FETCH_ALL_RSEE_DISCOUNT_REQUESTS_SUCCESS',
  FETCH_ALL_RSEE_DISCOUNT_REQUESTS_FAILED: 'FETCH_ALL_RSEE_DISCOUNT_REQUESTS_FAILED',
  FETCH_ALL_RSEE_DISCOUNT_REQUESTS_REJECT: 'FETCH_ALL_RSEE_DISCOUNT_REQUESTS_REJECT',

  FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_LOADING: 'FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_LOADING',
  FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_SUCCESS: 'FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_SUCCESS',
  FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_FAILED: 'FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_FAILED',
  FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_REJECT: 'FETCH_ALL_RSEE_DISCOUNT_REQUEST_ARCHIVES_REJECT',

  FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_LOADING: 'FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_LOADING',
  FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_SUCCESS: 'FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_SUCCESS',
  FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_FAILED: 'FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_FAILED',
  FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_REJECT: 'FETCH_RSEE_DISCOUNT_REQUEST_BY_ID_REJECT',

  UPDATE_RSEE_DISCOUNT_REQUEST_LOADING: 'UPDATE_RSEE_DISCOUNT_REQUEST_LOADING',
  UPDATE_RSEE_DISCOUNT_REQUEST_SUCCESS: 'UPDATE_RSEE_DISCOUNT_REQUEST_SUCCESS',
  UPDATE_RSEE_DISCOUNT_REQUEST_FAILED: 'UPDATE_RSEE_DISCOUNT_REQUEST_FAILED',
  UPDATE_RSEE_DISCOUNT_REQUEST_REJECT: 'UPDATE_RSEE_DISCOUNT_REQUEST_REJECT',

  ACTIVATE_RSEE_DISCOUNT_LOADING: 'ACTIVATE_RSEE_DISCOUNT_LOADING',
  ACTIVATE_RSEE_DISCOUNT_SUCCESS: 'ACTIVATE_RSEE_DISCOUNT_SUCCESS',
  ACTIVATE_RSEE_DISCOUNT_FAILED: 'ACTIVATE_RSEE_DISCOUNT_FAILED',
  ACTIVATE_RSEE_DISCOUNT_REJECT: 'ACTIVATE_RSEE_DISCOUNT_REJECT',

  CLEAR_CREATE_RSEE_DISCOUNT_REQUEST_FORM: 'CLEAR_CREATE_RSEE_DISCOUNT_REQUEST_FORM'
};
